import "swiper/swiper-bundle.css";

import { EffectFade, Navigation } from "swiper/modules";

import Swiper from "swiper";

Array.from(
	document.querySelectorAll("#project-list.swiper, #blog-list.swiper")
).map((grid) => {
	const progress = grid.querySelector("#progress");
	const totalSlides = Array.from(grid.querySelectorAll(".swiper-slide"))
		?.length;

	const swiper = new Swiper(grid, {
		modules: [EffectFade, Navigation],
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: false,
		autoHeight: true,
		navigation: {
			nextEl: ".swiper-next",
			prevEl: ".swiper-previous",
		},
		on: {
			init: function () {
				progress.textContent = `PG 1/${totalSlides}`;
			},
			slideChange: function () {
				progress.textContent = `PG ${swiper?.activeIndex + 1}/${totalSlides}`;
			},
		},
	});
});
